import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';

const RotaHeader = () => {
  return (
    <div className="flex justify-between items-center border-b border-gray-200 pb-4">
      <div>
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-1">
          <span className="cursor-pointer hover:underline">Rota</span>
          <span>&gt;</span>
          <span className="text-gray-900 font-medium">Add New Rota</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Add New Rota</h1>
        <p className="text-sm text-gray-500">Schedule staff, assign checks and ensure full operational coverage for the selected period.</p>
      </div>
      <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition">
        <FaArrowLeft className="text-xs" /> Back to Rota
      </button>
    </div>
  );
};

export default RotaHeader;
